const isSafari = /^(?:(?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent)

class SlideSection extends HTMLElement {
  constructor() {
    super()
    this.globalSlide = null
    setTimeout(() => {
      this.init()
    }, 50)
  }

  init() {
    if (document.body.classList.contains('index')) {
      let pos = window.pageYOffset
      if (pos > 0 || document.body.classList.contains('swiper-lazy')) {
        this.initSlide()
      } else {
        if (this.classList.contains('lazy-loading-swiper-before')) {
          this.initSlide()
        } else {
          this.classList.add('lazy-loading-swiper-after')
        }
      }
    } else {
      this.initSlide()
    }
  }

  initSlide() {
    const _this = this
    var autoplaying = _this?.dataset.autoplay === 'true'
    const loop = _this?.dataset.loop === 'true'
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : ''
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1
    const direction = _this?.dataset.direction ? _this?.dataset.direction : 'horizontal'
    var autoplaySpeed = _this?.dataset.autoplaySpeed ? _this?.dataset.autoplaySpeed * 1000 : 3000
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide'
    const row = _this?.dataset.row ? _this?.dataset.row : 1
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30
    var mobile_spacing = _this?.dataset.mobileSpacing ? _this?.dataset.mobileSpacing : spacing
    const progressbar = _this?.dataset.paginationProgressbar === 'true'
    const autoItem = _this?.dataset.itemMobile === 'true'
    const autoHeight = _this?.dataset.autoHeight === 'true'
    const arrowCenterimage = _this?.dataset.arrowCenterimage ? _this?.dataset.arrowCenterimage : 0
    const nextEl = document.querySelector(_this.dataset.nextEl)
    const prevEl = document.querySelector(_this.dataset.prevEl)
    spacing = Number(spacing)
    mobile_spacing = Number(mobile_spacing)
    autoplaySpeed = Number(autoplaySpeed)
    speed = Number(speed)
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed }
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1
      } else if (itemDesktop < 3) {
        itemTablet = 2
      } else {
        itemTablet = 3
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px'
    }

    const defaultOption = {
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: mobile_spacing >= 15 ? 15 : mobile_spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: nextEl || _this.querySelector('.swiper-button-next, .swiper-nav-next'),
        prevEl: prevEl || _this.querySelector('.swiper-button-prev, .swiper-nav-prev'),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector('.parent-pagination') || _this.querySelector('.swiper-pagination'),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest('.sec__tiktok-video')
          if (_this.classList.contains('slideshow')) {
            const motionElement = _this.querySelectorAll(
              `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup`
            )
            setTimeout(() => {
              motionElement &&
                motionElement.forEach(item => {
                  item.refreshAnimation()
                })
            }, 350)
          }
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
          )
          slide_visibles?.forEach(slide => {
            if (slide && typeof slide.initialize === 'function') {
              slide.initialize()
            }
          })
          e.autoplay.stop()
          if (_this?.dataset.autoplay === 'true') {
            motion.inView(
              _this,
              async () => {
                e.autoplay.start()
              },
              { margin: '0px 0px -50px 0px' }
            )
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok)
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok)
              }, 150)
            })
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll('.product-item__media--ratio')
            if (items_slide.length != 0) {
              var oH = []
              items_slide.forEach(e => {
                oH.push(e.offsetHeight / 2)
              })
              var max = Math.max(...oH)
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px'
              if (_this.querySelectorAll('.swiper-arrow')) {
                _this.querySelectorAll('.swiper-arrow').forEach(arrow => {
                  arrow.setAttribute('style', arrowsOffset)
                })
              }
            }
          }
          var video = _this.querySelector('video.slideshow')
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return
              observer.unobserve(_this)
              const videos = _this.querySelectorAll('video')
              videos.forEach(video => {
                const dataSrc = video.dataset.src
                if (dataSrc) {
                  video.src = dataSrc
                  video.removeAttribute('data-src')
                }
              })
            }
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: '0px 0px 200px 0px',
            }).observe(_this)
          }
        },
        realIndexChange: function (swiper) {
          if (_this?.dataset.autoplay) {
            var slide_visibles = _this.querySelectorAll(
              '.swiper-slide motion-element:not([data-image])'
            )
            slide_visibles?.forEach(slide => {
              if (!slide.hasAttribute('hold')) {
                slide?.setAttribute('hold', true)
              }
            })
          } else {
            var slide_visibles = _this.querySelectorAll(
              '.swiper-slide motion-element:not([data-image])'
            )
            slide_visibles?.forEach(slide => {
              if (!slide.hasAttribute('hold')) {
                slide?.setAttribute('hold', true)
              }
            })
          }

          setTimeout(() => {
            if (_this.classList.contains('slideshow')) {
              const motionElement = _this.querySelectorAll(
                `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup, .swiper-slide.swiper-slide-active  motion-element.motion-image`
              )
              motionElement &&
                motionElement.forEach(item => {
                  item.refreshAnimation()
                })
            }
          }, 50)
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`)
            allDots.forEach(dot => {
              dot.classList.remove('active')
            })
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" + index_currentSlide + "']"
              )
              .classList.add('active')
          }
        },
        afterInit() {
          _this.dispatchEvent(new Event('afterInit', { detail: _this.globalSlide }))
        },
      },
    }
    let additionalSwiperOptions = {}
    if (_this?.dataset.swiperOptions) {
      if (_this?.dataset.swiperOptions.trim().charAt(0) === '{') {
        additionalSwiperOptions = JSON.parse(_this?.dataset.swiperOptions)
      } else if (_this?.dataset.swiperOptions.startsWith('window.')) {
        additionalSwiperOptions = window[_this?.dataset.swiperOptions.slice(7)]
      } else if (_this?.dataset.swiperOptions.startsWith('window[')) {
        const key = _this?.dataset.swiperOptions.match(/window\[['"](.+?)['"]\]/)[1]
        additionalSwiperOptions = window[key]
      }
    }
    const swiperOptions = { ...defaultOption, ...additionalSwiperOptions }

    this.globalSlide = new Swiper(_this, swiperOptions)
  }

  initSecTiktok(sec) {
    sec.querySelectorAll('.swiper-slide').forEach(arrow => {
      const tiktok = arrow.querySelector('.section_tiktok-image')
      let width = '--item-width: ' + arrow.offsetWidth
      tiktok.setAttribute('style', width)
    })
  }
}
customElements.define('slide-section', SlideSection)

let dealToastLoading = false
let dealToastTemp = null
class Deal25Toast extends HTMLElement {
  constructor() {
    super()
    this.message = this.dataset.message || ''
    this.url = `${window.location.pathname}?section_id=deal25-toast`
    this.timer = null
    this.host = null
  }

  connectedCallback() {
    this.initToast()
    this.registeEvent()
  }

  async initToast() {
    if (dealToastLoading) return
    dealToastLoading = true
    const responseText = await fetch(this.url).then(response => response.text())
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const tempEl = html.querySelector('#deal25-toast')
    const styleEl = tempEl.querySelector('style')
    if (styleEl && !document.head.querySelector('style#deal25-toast-style')) {
      document.head.appendChild(styleEl.cloneNode(true))
    }
    dealToastTemp = tempEl.querySelector('#deal25-toast-html')
  }

  handleCopy(text) {
    if (isSafari || !navigator.clipboard) {
      const input = document.createElement('textarea')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.style.top = '-1000px'
      input.value = text
      document.body.appendChild(input)
      setTimeout(() => {
        input.focus()
        input.select()
        const ok = document.execCommand('copy')
        input.remove()
        if (!ok) {
          throw new Error('Copy command was unsuccessful')
        }
      }, 4)
      return
    }
    navigator.clipboard.writeText(text)
  }

  handleClick(e) {
    const target = e.target
    const msg = target.dataset.toast || this.message
    const duration = this.dataset.duration ? Number.parseInt(this.dataset.duration) : 1000

    const beforeCb = () => {
      if (target.dataset.code)
        this.handleCopy(target.dataset.code)
    }
    const cb = () => {
      if (target.dataset.href)
        window.location.href = target.dataset.href
    }

    this.show(msg, { duration, beforeCb, cb })
  }

  registeEvent() {
    this.clickEvent = this.handleClick.bind(this)
    const triggerEl = this.querySelectorAll('[data-toast]')
    if (!triggerEl)
      return
    triggerEl.forEach((el) => {
      el.addEventListener('click', this.clickEvent)
    })
  }

  async getToast(msg) {
    let toastEl = null
    toastEl = dealToastTemp.cloneNode(true)
    if (msg) {
      const textHemlEl = toastEl.querySelector('.text')
      textHemlEl.textContent = msg
    }

    return toastEl
  }

  hide() {
    this.host.classList.remove('show')
    clearTimeout(this.timer)
    this.timer = null
    this.host.hidden = true
  }

  appendToaset() {
    if (window.innerWidth < 768) {
      document.body.appendChild(this.host)
    }
    else {
      this.appendChild(this.host)
    }
  }

  async show(message = this.message, opts) {
    const _that = this
    opts = opts || {}
    if (this.host) {
      if (this.host.classList.contains('show')) {
        this.hide()
      }
    }
    else {
      this.host = await this.getToast(message)
      this.appendToaset()
    }
    this.host.hidden = false
    setTimeout(() => {
      this.host.classList.add('show')
    }, 20)
    clearTimeout(this.timer)
    if (opts.beforeCb) {
      opts.beforeCb()
    }
    const duration = typeof opts.duration === 'number' ? opts.duration : 1000
    this.timer = setTimeout(() => {
      _that.hide()
      opts.cb && opts.cb()
    }, duration)
  }
}

customElements.define("deal25-toast", Deal25Toast);

/* 组件 tabs-navigation */
class WWTabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".ww-tab__tab-item");
    this.select = this.querySelector(".ww-tab__select-tab");
    this.content = this.querySelectorAll(".ww-tab__tab-content");
    this.init();

    if (Shopify.designMode) {
      this.tabNav = this.querySelector("tabs-navigation");
      this.addEventListener("shopify:block:select", function (e) {
        const hasEl = [...this.content].find(
          (el) => e.target === el || el.contains(e.target)
        );
        if (!hasEl) return;
        const tab = [...this.tabs].find(
          (t) => t.dataset.blockId == hasEl.dataset.blockId
        );
        this.tabNav.activateTab(tab.dataset.blockId, tab);
        this.onClick(tab);
      });
    }
  }
  init() {
    const self = this;
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        self.onClick(this);
      });
    });
  }
  onClick(tab) {
    if (!tab) return;
    const blockId = tab.dataset.blockId;
    console.log("🚀 ~ blockId:", blockId);
    this.showContent(blockId);
    this.tabs.forEach((t) => {
      t.classList.remove("active");
    });
    tab.classList.add("active");
  }

  showContent(blockId) {
    this.content.forEach((content) => {
      if (content.dataset.blockId === blockId) {
        content.classList.add("active");
        let motion_element = content.querySelectorAll("motion-element");
        motion_element.forEach((motion) => {
          motion.refreshAnimation();
        });
      } else {
        content.classList.remove("active");
      }
    });
  }
}
customElements.define("ww-tab-items", WWTabItems);
/* 组件 tabs-navigation */



class TabsLoadMore extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId
    this.param = this.dataset.param
    this.total = parseInt(this.dataset.total)
    this.count = parseInt(this.dataset.count)
    this.currentPage = 1
    this.paginationEl = this.querySelector('.t4s-prs-pagination')
    this.loadMoreBtn = this.querySelector('.t4s-loadmore-btn')
    this.currentPageEl = this.querySelector('[data-current-bar]')
    this.loadMoreBar = this.querySelector('.t4s-lm-bar--current')
    this.clickHandler = this.handleClick.bind(this)
    this.init()
  }

  init() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.clickHandler)
    }
  }

  handleClick(e) {
    e.preventDefault()
    this.loadMoreProducts()
  }

  getSectionInnerHTML(html, selector) {
    const blockEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
    return {
      innerHtml: blockEl?.innerHTML || '',
      offset: blockEl?.dataset.offset || 0,
    }
  }

  updateEvents() {
    T4SThemeSP.reinitProductGridItem()
  }
  async loadMoreProducts() {
    if (this.currentPage >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `?section_id=${this.sectionId}&${this.param}=${this.currentPage + 1}`
      )
      if (!response.ok) return

      const data = await response.text()
      const { innerHtml, offset } = this.getSectionInnerHTML(
        data,
        `#${this.id} [data-contentlm-replace]`
      )

      if (innerHtml) {
        this.querySelector('[data-contentlm-replace]').insertAdjacentHTML('beforeend', innerHtml)
        this.currentPage++
        this.offset = offset
        this.updateEvents()
      }

      if (this.currentPage >= this.total) {
        this.paginationEl.remove()
      } else {
        this.currentPageEl.innerHTML = this.offset
        this.loadMoreBar.style.width = `${(this.offset / this.count) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}

customElements.define('tabs-loadmore', TabsLoadMore)

/**
 * LoginCheck Component
 * 登录检查组件 - 用于处理需要登录才能执行的操作
 * 
 * 使用方法：
 * <login-check 
 *   data-activity-type="activity_7"
 *   data-must-agree-email="true"
 *   data-check-immediately="true"
 *   data-redirect="/thank-you"
 * >
 *   <button data-login>Login</button>
 * </login-check>
 */
class LoginCheck extends HTMLElement {
  constructor() {
    super()
    this.loginDialog = document.querySelector('login-dialog')
  }

  init() {
    this.addEventListener('click', this.clickEvent, true)
  }

  connectedCallback() {
    this.loginType = this.dataset.loginType || 'modal'
    this.clickEvent = this.onClick.bind(this)
    this.watchLoginEvent()
    this.init()
  }

  showHiddenEl() {
    this.querySelectorAll('[data-login-show]').forEach(el => {
      el.classList.remove('hidden')
    })
  }

  watchLoginEvent() {
    document.addEventListener('LUTE:AUTH:LOGIN', e => {
      this.removeEventListener('click', this.clickEvent, true)
      this.showHiddenEl()
    })
  }

  /**
   * 获取登录选项配置
   * @returns {Object} 登录选项对象
   */
  getLoginOptions() {
    const options = {}

    // 活动类型
    if (this.dataset.activityType) {
      options.activityType = this.dataset.activityType
    }

    // // 是否必须同意邮件订阅
    // if (this.dataset.mustAgreeEmail) {
    //   options.mustAgreeEmail = this.dataset.mustAgreeEmail === 'true'
    // }

    // // 是否立即检查
    // if (this.dataset.checkImmediately) {
    //   options.checkImmediately = this.dataset.checkImmediately === 'true'
    // }

    // // 重定向URL
    // if (this.dataset.redirect) {
    //   options.redirect = this.dataset.redirect
    // }

    return options
  }

  onClick(e) {
    if (e.target.hasAttribute('data-login')) {
      e.preventDefault()
      e.stopPropagation()
      if (this.loginType === 'link') {
        const link =
          this.dataset.link ||
          `${window.__MC__CONFIG__.accountSiteUrl}/login?redirect=${window.location.origin}&source=shopify-site`
        window.location.href = link
        return
      }
      const loginDialog = document.querySelector('login-dialog')

      // 获取登录选项并传递给 loginDialog
      const options = this.getLoginOptions()
      const hasOptions = Object.keys(options).length > 0

      if (hasOptions) {
        loginDialog?.open(null, options)
      } else {
        loginDialog?.open()
      }
    }
  }
}

customElements.define('login-check', LoginCheck)

/**
 * ActivityTracker — 活动页埋点组件
 *
 * 功能：
 * 1. Section 浏览 UV：IntersectionObserver 监测各 section 进入视口，上报 activity:section_view
 * 2. 加购事件 section 标识：监听 ATC 点击，上报 activity:add_to_cart 并附带 section_id
 * 3. 活动页链接参数注入：同域链接自动追加 act_id / act_section 查询参数
 *
 * 使用方式（放在活动页模板的任意 section 中）：
 * <activity-tracker data-activity-id="deal25"></activity-tracker>
 */
class ActivityTracker extends HTMLElement {
  #observer = null
  #viewedSections = new Set()
  #atcHandler = null
  #linkHandler = null
  #bmsmHandler = null
  #bmsmSectionId = ''
  #root = null

  connectedCallback() {
    this.activityId = this.dataset.activityId || location.pathname.split('/').pop() || ''
    this.#root = document.querySelector('div.landing-page')
    if (!this.#root) return
    this.#initSectionView()
    this.#initAtcTracking()
    this.#initBmsmTracking()
    this.#initLinkDecoration()
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
    if (this.#atcHandler) document.removeEventListener('click', this.#atcHandler, true)
    if (this.#linkHandler) document.removeEventListener('mousedown', this.#linkHandler)
    if (this.#bmsmHandler) {
      document.removeEventListener('LUTE:BMSM:ADD', this.#bmsmHandler)
      document.removeEventListener('LUTE:BMSM:ADDED', this.#bmsmHandler)
      document.removeEventListener('LUTE:BMSM:OPEN', this.#bmsmHandler)
      this.#bmsmHandler = null
    }
    if (this.#cartSuccessHandler) {
      const $ = window.jQuery_T4NT || window.jQuery
      $?.(document).off('add:cart:success', this.#cartSuccessHandler)
      this.#cartSuccessHandler = null
    }
  }

  #isInScope(el) {
    return this.#root && this.#root.contains(el)
  }

  #getSectionId(el) {
    const wrapper = el.closest('[id^="shopify-section-"]')
    return wrapper ? wrapper.id.replace('shopify-section-', '') : ''
  }

  /** 1. Section 浏览 UV — 每个 section 仅上报一次 */
  #initSectionView() {
    const sections = this.#root.querySelectorAll('[id^="shopify-section-"]')
    if (!sections.length) return

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          const id = entry.target.id.replace('shopify-section-', '')
          if (this.#viewedSections.has(id)) continue
          this.#viewedSections.add(id)
          luteTrack('activity:section_view', {
            activity_id: this.activityId,
            section_id: id,
          })
          this.#observer.unobserve(entry.target)
        }
      },
      { threshold: 0.3 }
    )

    sections.forEach((s) => this.#observer.observe(s))
  }

  /**
   * 2. 加购事件 + section 标识 — 仅在 ATC 表单/按钮提交成功后才上报
   *    两步流程：
   *    a) 点击 [data-action-quickshop] → 记录来源 section_id
   *    b) 点击 [data-atc-form]（弹窗内，可能在 .landing-page 外）→ 暂存 payload
   *    单步流程：直接点击 [data-action-atc] → 暂存 payload
   *    最终：监听 jQuery `add:cart:success`（主题在 ATC 成功后触发）→ 真正上报
   */
  #pendingSectionId = ''
  #pendingPayload = null
  #cartSuccessHandler = null
  #initAtcTracking() {
    this.#atcHandler = (e) => {
      const target = e.target

      // 单步加购（直接 ATC 按钮在 landing-page 内）
      const atcBtn = target.closest('[data-action-atc]')
      if (atcBtn && this.#isInScope(atcBtn)) {
        this.#pendingPayload = {
          activity_id: this.activityId,
          section_id: this.#getSectionId(atcBtn),
          product_id: atcBtn.dataset.id || '',
        }
        return
      }

      // 两步加购 — 第一步：quickshop 触发，暂存 section_id
      const qsBtn = target.closest('[data-action-quickshop]')
      if (qsBtn && this.#isInScope(qsBtn)) {
        this.#pendingSectionId = this.#getSectionId(qsBtn)
        return
      }

      // 两步加购 — 第二步：弹窗内 atc-form 提交（不在 landing-page 内也可）
      const formBtn = target.closest('[data-atc-form]')
      if (formBtn && this.#pendingSectionId) {
        const form = formBtn.closest('form')
        const variantInput = form?.querySelector('[name="id"]')
        const productInput = form?.querySelector('[name="product-id"]')
        this.#pendingPayload = {
          activity_id: this.activityId,
          section_id: this.#pendingSectionId,
          variant_id: variantInput?.value || '',
          product_id: productInput?.value || '',
        }
        this.#pendingSectionId = ''
      }
    }
    document.addEventListener('click', this.#atcHandler, true)

    // 监听 ATC 成功事件（主题用 jQuery 触发）
    const $ = window.jQuery_T4NT || window.jQuery
    if ($) {
      this.#cartSuccessHandler = () => {
        if (!this.#pendingPayload) return
        luteTrack('activity:add_to_cart', this.#pendingPayload)
        this.#pendingPayload = null
      }
      $(document).on('add:cart:success', this.#cartSuccessHandler)
    }
  }

  #initBmsmTracking() {
    const buyMoreEl = this.#root.querySelector('.buy-more-save-more, buy-more-save-more')
    if (!buyMoreEl) return

    this.#bmsmSectionId = this.#getSectionId(buyMoreEl)
    if (!this.#bmsmSectionId) return

    this.#bmsmHandler = (event) => {
      const detail = event.detail || {}

      if (event.type === 'LUTE:BMSM:ADD') {
        // 直接上报用户在 BMSM 模块内添加商品的行为
        luteTrack('activity:bmsm_add', {
          activity_id: this.activityId,
          section_id: this.#bmsmSectionId,
          product_id: detail.id || detail.pid || '',
          quantity: detail.quantity || 1,
          add_source: 'bmsm',
        })
        return
      }

      if (event.type === 'LUTE:BMSM:ADDED') {
        const payload = {
          activity_id: this.activityId,
          section_id: this.#bmsmSectionId,
          add_source: 'bmsm',
        }
        if (Array.isArray(detail.productList)) {
          payload.product_count = detail.productList.length
          payload.product_ids = detail.productList.map((item) => item.id).filter(Boolean)
        }
        luteTrack('activity:bmsm_add_to_cart', payload)
        return
      }

      if (event.type === 'LUTE:BMSM:OPEN') {
        luteTrack('activity:bmsm_open', {
          activity_id: this.activityId,
          section_id: this.#bmsmSectionId,
        })
      }
    }

    document.addEventListener('LUTE:BMSM:ADD', this.#bmsmHandler)
    document.addEventListener('LUTE:BMSM:ADDED', this.#bmsmHandler)
    document.addEventListener('LUTE:BMSM:OPEN', this.#bmsmHandler)
  }

  /** 3. 同域链接注入 act_id + act_section 参数（只要一级域名一致即可） */
  #getRootDomain(hostname) {
    if (!hostname) return ''
    // IP / localhost 直接原样返回
    if (/^[\d.]+$/.test(hostname) || !hostname.includes('.')) return hostname
    const parts = hostname.split('.')
    // 简单处理：取最后两段（足以覆盖 momcozy.com / shop.momcozy.com 这类场景）
    return parts.slice(-2).join('.')
  }

  #initLinkDecoration() {
    const currentRoot = this.#getRootDomain(location.hostname)
    this.#linkHandler = (e) => {
      const link = e.target.closest('a[href]')
      if (!link || !this.#isInScope(link)) return
      try {
        const url = new URL(link.href, location.origin)
        if (this.#getRootDomain(url.hostname) !== currentRoot) return
        if (url.pathname === location.pathname && url.hash) return
        if (url.searchParams.has('act_id')) return
        const sectionId = this.#getSectionId(link)

        // ref：当前页面链接，并带上本次的 act_id / act_section
        const refUrl = new URL(location.href)
        refUrl.searchParams.set('act_id', this.activityId)
        if (sectionId) refUrl.searchParams.set('act_section', sectionId)
        url.searchParams.set('ref', refUrl.toString())

        link.href = url.toString()
      } catch {
        // ignore invalid URLs
      }
    }
    document.addEventListener('mousedown', this.#linkHandler)
  }
}

customElements.define('activity-tracker', ActivityTracker)


/**
 * TabsSlider — 标签页滑块组件
 *
 * 职责：
 *   1. 管理按钮激活状态（active / aria-selected）
 *   2. 维护 clip-path 滑动指示器位置
 *   3. 按钮点击事件委托
 *   4. 派发 tab-select 事件通知外部
 *   5. 按钮横向滚动居中
 *
 * 结构：
 *   <tabs-slider class="tabs-navigation count-3">
 *     <div class="tabs-container">
 *       <div class="tabs-scroll-container">
 *         <div class="tabs-wrapper">
 *           <button class="tab-button" data-tab-id="id1">Tab1</button>
 *           <button class="tab-button" data-tab-id="id2">Tab2</button>
 *           <!-- .slider 由 JS 自动创建 -->
 *         </div>
 *       </div>
 *     </div>
 *   </tabs-slider>
 */
class TabsSlider extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector('.tabs-wrapper')
    this.scrollContainer = this.querySelector('.tabs-scroll-container') || this
    this.buttons = Array.from(this.wrapper.querySelectorAll('.tab-button'))

    // 创建指示器，放入 wrapper 内
    this._indicator = document.createElement('div')
    this._indicator.classList.add('slider')
    this.wrapper.appendChild(this._indicator)

    // 事件委托
    this._handleClick = this._handleClick.bind(this)
    this.addEventListener('click', this._handleClick)

    // 初始化激活：优先已有 .active 的按钮，否则第一个
    const activeBtn = this.wrapper.querySelector('.tab-button.active') || this.buttons[0]
    if (activeBtn) {
      this.select(activeBtn.dataset.tabId, activeBtn)
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick)
  }

  _handleClick(e) {
    const button = e.target.closest('.tab-button')
    if (!button || !this.contains(button)) return
    this.select(button.dataset.tabId, button)
  }

  /**
   * 激活指定标签
   * @param {string} tabId - 标签 ID
   * @param {HTMLElement} [button] - 可选，直接传入按钮元素避免查找
   */
  select(tabId, button) {
    if (!tabId) return
    const target = (button && this.buttons.includes(button))
      ? button
      : this.buttons.find(b => b.dataset.tabId === tabId)
    if (!target) return

    this.buttons.forEach(b => {
      const isActive = b === target
      b.classList.toggle('active', isActive)
      b.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    this._moveIndicator(target)
    this._moveButtonToCenter(target)

    this.dispatchEvent(new CustomEvent('tab-select', {
      bubbles: true,
      detail: { tabId, button: target },
    }))
  }

  _moveButtonToCenter(button) {
    const sc = this.scrollContainer
    if (sc.scrollWidth <= sc.clientWidth) return
    const buttonRect = button.getBoundingClientRect()
    const wrapperRect = this.wrapper.getBoundingClientRect()
    const scRect = sc.getBoundingClientRect()
    const scrollLeft =
      buttonRect.left - wrapperRect.left - (scRect.width - buttonRect.width) / 2
    sc.scrollTo({
      left: scrollLeft,
      behavior: 'smooth',
    })
  }

  _moveIndicator(button) {
    if (!button || !this._indicator) return
    const { offsetLeft, offsetWidth } = button
    const containerWidth = this.wrapper.offsetWidth
    if (!containerWidth) return
    const left = Number((offsetLeft / containerWidth) * 100).toFixed()
    const right = Number(100 - ((offsetLeft + offsetWidth) / containerWidth) * 100).toFixed()
    this._indicator.style.clipPath = `inset(0 ${right}% 0 ${left}% round 99px)`
  }
}

if (!customElements.get('tabs-slider')) customElements.define('tabs-slider', TabsSlider)


class ActivityTabsNav extends HTMLElement {
  constructor() {
    super()
    this._onTabSelect = this._onTabSelect.bind(this)
    this._currentAnimation = null
  }

  connectedCallback() {
    // 查找已有的 <tabs-slider>
    this.slider = this.querySelector('tabs-slider')

    // 监听 slider 的 tab-select 事件
    this.slider.addEventListener('tab-select', this._onTabSelect)
  }

  disconnectedCallback() {
    this.slider?.removeEventListener('tab-select', this._onTabSelect)
    if (this._currentAnimation) {
      this._currentAnimation.cancel()
      this._currentAnimation = null
    }
  }

  _onTabSelect(e) {
    const { tabId, button } = e.detail
    this._switchContent(tabId)
    this.dispatchEvent(
      new CustomEvent('tab-changed', {
        bubbles: true,
        detail: { tabId },
      })
    )
  }

  _switchContent(tabId) {
    // 取消正在进行的动画，防止竞态
    if (this._currentAnimation) {
      this._currentAnimation.cancel()
      this._currentAnimation = null
    }

    const from = this.querySelector('[data-tab-content].active')
    const to = this.querySelector(`[data-tab-content="${CSS.escape(tabId)}"]`)
    if (!to) return

    if (from && from !== to) {
      this._currentAnimation = from.animate(
        { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-15px)'] },
        { duration: 250, easing: 'ease' }
      )
      this._currentAnimation.onfinish = () => {
        this._currentAnimation = null
        from.classList.remove('active')
        to.classList.add('active')
        to.animate(
          { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
          { duration: 300, easing: 'ease' }
        )
      }
    } else if (!from) {
      // 首次激活，无需淡出
      to.classList.add('active')
    }
  }

  /**
   * 公共 API — 供外部组件调用（如 WWTabItems）
   * @param {string} tabId
   * @param {HTMLElement} [button]
   */
  activateTab(tabId, button) {
    this.slider.select(tabId, button)
  }
}

// 注册自定义元素
customElements.define('activity-tabs-nav', ActivityTabsNav)

/* ===== PDP Info Modal Web Component ===== */
if (!customElements.get('pdp-info-modal')) {
  class PdpInfoModal extends HTMLElement {
    constructor() {
      super();
      this._overlay = null;
      this._titleEl = null;
      this._bodyEl = null;
      this._slots = {};
      this._customClass = []
    }

    static get observedAttributes() {
      return ['open'];
    }

    connectedCallback() {
      this._slots = {};
      for (const tpl of this.querySelectorAll('template')) {
        const name = tpl.getAttribute('slot') || 'body';
        this._slots[name] = tpl.innerHTML;
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this);
      if (this._overlay) {
        this._overlay.removeEventListener('click', this);
        this._overlay.remove();
        this._overlay = null;
      }
    }

    /* — handleEvent: single event router — */
    handleEvent(e) {
      switch (e.type) {
        case 'click':
          if (e.target.closest('[data-close]')) {
            this.open = false;
          } else if (!this.closeOnly && e.target === this._overlay) {
            this.open = false;
          }
          break;
        case 'keydown':
          if (e.key === 'Escape' && !this.closeOnly) this.open = false;
          else if (e.key === 'Tab') this._trapFocus(e);
          break;
        case 'transitionend':
          if (e.target === this._overlay && !this.open) {
            this._afterClose();
          }
          break;
      }
    }

    /* — Attribute-driven state — */
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
      if (name === 'open') {
        newValue !== null ? this._onShow() : this._onClose();
      }
    }

    get open() {
      return this.hasAttribute('open');
    }

    get closeOnly() {
      return this.hasAttribute('close-only');
    }

    set open(val) {
      val ? this.setAttribute('open', '') : this.removeAttribute('open');
    }

    /* — Public API (matches <dialog> convention) — */
    show() {
      if (this.open) {
        this._onShow();
      } else {
        this.open = true;
      }
    }

    close() {
      this.open = false;
    }

    setTitle(text) {
      this.dataset.title = text;
      if (this._titleEl) this._titleEl.textContent = text;
    }

    setContent(html, className = '') {
      this._slots.body = html;
      if (this._bodyEl) {
        this._bodyEl.innerHTML = html;
        this._bodyEl.className = `pdp-info-modal__body ${className}`;
      }
    }

    setClass(className) {
      this._customClass = className ? className.split(/\s+/).filter(Boolean) : [];
      if (this._overlay) {
        this._overlay.classList.add(...this._customClass);
      }
    }

    /* — Private helpers — */
    _onShow() {
      this._triggerEl = document.activeElement;
      this._ensureOverlay();
      requestAnimationFrame(() => {
        this._overlay.classList.add('is-open');
        document.documentElement.classList.add('pdp-scroll-lock');
        document.addEventListener('keydown', this);
        /* Focus the close button or first focusable element */
        const firstFocusable = this._overlay.querySelector('[data-close], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      });
      this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { open: true } }));
    }

    _onClose() {
      if (!this._overlay) return;
      this._overlay.classList.remove('is-open');
      document.removeEventListener('keydown', this);

      this._closeTimer = setTimeout(() => this._afterClose(), 350);
      this._overlay.addEventListener('transitionend', this);

      this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { open: false } }));
    }

    _afterClose() {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
      if (this._overlay) this._overlay.removeEventListener('transitionend', this);
      document.documentElement.classList.remove('pdp-scroll-lock');
      /* Restore focus to the element that opened the modal */
      if (this._triggerEl && typeof this._triggerEl.focus === 'function') {
        this._triggerEl.focus();
        this._triggerEl = null;
      }
    }

    /** Trap Tab/Shift+Tab within the modal overlay */
    _trapFocus(e) {
      if (!this._overlay) return;
      const focusable = this._overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    _ensureOverlay() {
      if (this._overlay) return;

      const tpl = document.getElementById('pdp-info-modal-tpl');
      const overlay = tpl.content.firstElementChild.cloneNode(true);
      const header = overlay.querySelector('.pdp-info-modal__header');

      if (this._slots.header) {
        header.innerHTML = this._slots.header;
      } else if (this.dataset.title) {
        const titleEl = header.querySelector('.pdp-info-modal__title');
        if (titleEl) titleEl.textContent = this.dataset.title;
      }

      this._titleEl = overlay.querySelector('.pdp-info-modal__title');
      this._bodyEl = overlay.querySelector('.pdp-info-modal__body');

      if (this._slots.body && this._bodyEl) {
        this._bodyEl.innerHTML = this._slots.body;
      }

      overlay.addEventListener('click', this);
      if (this._customClass) {
        overlay.classList.add(...this._customClass);
      }
      document.body.appendChild(overlay);
      this._overlay = overlay;
    }
  }

  customElements.define('pdp-info-modal', PdpInfoModal);
}

/* ===== PDP Info Button — Opens a PdpInfoModal with inline <template> content ===== */
if (!customElements.get('pdp-info-btn')) {
  class PdpInfoBtn extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this._modal = null;

      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

      this.addEventListener('click', this);
      this.addEventListener('keydown', this);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this);
      this.removeEventListener('keydown', this);
    }

    handleEvent(e) {
      if (e.type === 'click') {
        this._showModal();
      } else if (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        this._showModal();
      }
    }

    _getModal() {
      if (!this._modal) {
        this._modal = document.createElement('pdp-info-modal');
        this.appendChild(this._modal);
      }
      return this._modal;
    }

    _showModal() {
      const modal = this._getModal();
      const tpl = this.querySelector('template');
      if (tpl) {
        modal.setTitle(this.dataset.title || tpl.dataset.title || '');
        modal.setContent(tpl.innerHTML);
      }
      if (this.dataset.modalClass) {
        modal.setClass(this.dataset.modalClass);
      }
      if (this.dataset.closeOnly === 'true' || this.dataset.closeOnly === '') {
        modal.setAttribute('close-only', '');
      } else {
        modal.removeAttribute('close-only');
      }
      modal.show();
    }
  }

  customElements.define('pdp-info-btn', PdpInfoBtn);
}
